document.addEventListener("teeinblue-event-after-cart-added", () => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
      .then((res) => res.json())
      .then((res) => drawer.renderContents({ sections: res }));
    if (drawer.classList.contains("is-empty"))
      drawer.classList.remove("is-empty");
  }

  var request = new XMLHttpRequest();
  request.open("GET", "/cart.js", true);
  request.onload = function () {
    if (this.status >= 200 && this.status < 400) {
      var data = JSON.parse(this.response);
      var itemCount = data.item_count;
      var cartCount = document.querySelector("#CartCount");

      if (cartCount) {
        cartCount.innerText = itemCount;
      }
    }
  };

  request.send();
});

const checkSizingChart = () => {
  var sizingChart = document.querySelector(".mfp.sizelink");
  var teeOptionTitle = document.querySelector(
    ".tee-option--size .tee-option__title"
  );
  if (sizingChart && teeOptionTitle) {
    var existingClone = teeOptionTitle.querySelector(".mfp.sizelink");
    if (!existingClone) {
      var sizingChartClone = sizingChart.cloneNode(true);
      teeOptionTitle.appendChild(sizingChartClone);
      sizingChartClone.addEventListener("click", function () {
        sizingChart.click();
      });
    }
  }
};
document.addEventListener("teeinblue-event-variant-changed", checkSizingChart);
document.addEventListener("teeinblue-event-component-injected", () => {
  const checkElementRendered = setInterval(() => {
    if (document.querySelector(".mfp.sizelink")) {
      checkSizingChart();
      clearInterval(checkElementRendered);
    }
  }, 1000);
  document
    .querySelectorAll(".tee-available-products .tee-radio")
    .forEach((radio) => {
      radio.addEventListener("click", () => {
        setTimeout(() => {
          checkSizingChart();
        }, 200);
      });
    });
});

/* ===== TSB: Eigener Text im Dropdown hervorheben – START ===== */

const highlightCustomTextOption = () => {
  document.querySelectorAll(".dropdown-wy--tsb option").forEach((option) => {
    if (option.textContent.trim() === "Eigener Text") {
      option.classList.add("custom-text-option--tsb");
    }
  });
};

document.addEventListener(
  "teeinblue-event-component-injected",
  highlightCustomTextOption
);

document.addEventListener(
  "teeinblue-event-variant-changed",
  highlightCustomTextOption
);

document.addEventListener("DOMContentLoaded", highlightCustomTextOption);

/* ===== TSB: Eigener Text im Dropdown hervorheben – ENDE ===== */

/* ===== WOWYOU: Stylebeschreibung-Button – START ===== */

function insertStyleInfoButtonTsb() {
  const form = document.querySelector(".tee-customize-main-form");

if (!form || !form.parentNode) return;

// Bereits vorhandenen Button wiederverwenden
let existingWrapper = document.querySelector(".wowyou-style-action--tsb");

if (existingWrapper) {
  form.before(existingWrapper);
  return;
}

  const wrapper = document.createElement("div");
  wrapper.className = "tee-form-action wowyou-style-action--tsb";

  const button = document.createElement("button");
  button.type = "button";
  button.className = "tee-btn tee-btn--full tee-btn--preview wowyou-style-button--tsb";
  button.innerHTML = `
  <span class="wowyou-style-icon--tsb" aria-hidden="true">💡</span>
  <span class="wowyou-style-content--tsb">
    <span class="wowyou-style-title--tsb">
      Tipps für dein perfektes WOW-Design
    </span>
    <span class="wowyou-style-subtitle--tsb">
      Mit ein paar einfachen Tipps wird dein Kunstwerk noch besser.
    </span>
  </span>
`;


  button.addEventListener("click", function () {
    const styleTab = document.querySelector(
      '#productTabs a.tablink[href="#ptabDesc"]'
    );

    const target = document.querySelector("#productTabs");

    if (!styleTab || !target) return;

    // Style-Tab aktivieren, falls ein anderer geöffnet ist
    styleTab.click();

    // Anschließend sanft zu den Tabs scrollen
    requestAnimationFrame(() => {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });
  });


  wrapper.appendChild(button);
  form.before(wrapper);
}

document.addEventListener(
  "teeinblue-event-component-injected",
  insertStyleInfoButtonTsb
);

document.addEventListener(
  "teeinblue-event-variant-changed",
  insertStyleInfoButtonTsb
);

document.addEventListener(
  "DOMContentLoaded",
  insertStyleInfoButtonTsb
);

/* ===== WOWYOU: Stylebeschreibung-Button – ENDE ===== */ 